const topics = [
  { id: 1, label: '流浪地球3', heat: '98万讨论', trend: 'up', colorClass: 'bg-primary-100 text-primary-700' },
  { id: 2, label: '高分韩剧推荐', heat: '85万讨论', trend: 'up', colorClass: 'bg-accent-100 text-accent-700' },
  { id: 3, label: '悬疑烧脑', heat: '76万讨论', trend: 'up', colorClass: 'bg-secondary-100 text-secondary-700' },
  { id: 4, label: '国产动画崛起', heat: '68万讨论', trend: 'hot', colorClass: 'bg-primary-100 text-primary-700' },
  { id: 5, label: '暑期追剧指南', heat: '62万讨论', trend: 'hot', colorClass: 'bg-accent-100 text-accent-700' },
  { id: 6, label: '经典港片', heat: '55万讨论', trend: 'up', colorClass: 'bg-secondary-100 text-secondary-700' },
  { id: 7, label: '4K高清资源', heat: '48万讨论', trend: 'new', colorClass: 'bg-primary-100 text-primary-700' },
  { id: 8, label: '西瓜视频免费', heat: '43万讨论', trend: 'up', colorClass: 'bg-accent-100 text-accent-700' },
  { id: 9, label: '日漫新番', heat: '39万讨论', trend: 'new', colorClass: 'bg-secondary-100 text-secondary-700' },
  { id: 10, label: '免费视频网站91', heat: '35万讨论', trend: 'up', colorClass: 'bg-primary-100 text-primary-700' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-16 md:py-24 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            热门话题
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-[600px] mx-auto">
            大家都在讨论的热门影视话题，加入讨论发现更多好片
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 md:gap-4">
          {topics.map((topic) => (
            <div
              key={topic.id}
              className={`group flex items-center gap-3 px-5 py-3 rounded-full ${topic.colorClass} cursor-pointer transition-all duration-300 hover:scale-105`}
            >
              <span className="text-sm md:text-base font-medium whitespace-nowrap">
                #{topic.label}
              </span>
              <span className="text-xs opacity-70 whitespace-nowrap">{topic.heat}</span>
              {topic.trend === 'hot' && (
                <i className="ri-fire-line text-xs animate-pulse"></i>
              )}
              {topic.trend === 'up' && (
                <i className="ri-arrow-up-line text-xs"></i>
              )}
              {topic.trend === 'new' && (
                <span className="text-[10px] font-bold px-1.5 py-0.5 rounded bg-background-50/60">NEW</span>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}